import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Button, Form, InputGroup } from 'react-bootstrap';
import { getRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../../components/CustomAlert';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import UserManagementDataTable from '../DataTables/UserManagementDataTable';
import AddUserModal from '../Modals/AddUserModal';
import EditUserModal from '../Modals/EditUserModal';
import plusIcon from '../../assets/SidebarIcons/icon-plus.svg'
import './_userManagement.scss'

const UserManagement = () => {
    const { access_token } = useSelector((state) => state.auth.user)
    const [loadingData, setLoadingData] = useState(false);
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [countryOpts, setCountryOpts] = useState([]);
    const [selectedUser, setSelectedUser] = useState({});

    const closeModal = () => {
        setShowAddModal(false);
        setShowEditModal(false);
      }

    const openModal = (mode, row) => {
        if (mode === 'add') {
          setShowAddModal(true)
          return
        }
        if (mode === 'edit') {
          getUserDetail(row.id)
          return
        }
      }

    const [alertState, setAlertState] = useState({
        show: false,
        variant: 'danger',
        message: '',
    });

    const getUserData = () => {
        setLoadingData(true);
        const data = { headers: { Authorization: access_token.token } };
        getRequest(`/admin/user-management`, data, (res) => {
            if (res.success) {
                const result = res.data;
                setData(result);
                setSearchData(result);
            } else {
                setAlertState({
                    message: 'There was an issue while fetching user credits',
                    show: true,
                    variant: 'danger',
                });
            }
            setLoadingData(false);
        });
    };

    const get_countries = async () => {
        const data = {
          headers: { Authorization: access_token?.token },
        };
        getRequest('/v2/country-all', data, (res) => {
          if (res.success) {
            const { data } = res;
            const country_options = data.map(item => ({
              value: item.iso2,
              label: `${item.name} (${item.iso2})`,
            }));
            setCountryOpts(country_options)
          }
        });
    }

    const getUserDetail = (id) => {
      const header = { headers: { Authorization: access_token.token } };

      getRequest(`/admin/user-management/${id}`, header, (res) => {
        if (res.success) {
          setShowEditModal(true)
          setSelectedUser(res.data)
        } else {
          setAlertState({
            message: 'There was an issue while fetching user data',
            show: true,
            variant: 'danger',
          });
        }
      });
    }

    const onSearch = (evt) => {
        const { value } = evt.target;
        const filteredData = data.filter((item) =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.email.toLowerCase().includes(value.toLowerCase())
        );

        setSearch(value);
        setSearchData(value ? filteredData : data);
    };

    useEffect(() => {
        getUserData();
        get_countries();
    }, []);

    useEffect(() => {
        if (alertState.show) {
            setTimeout(() => {
                setAlertState({
                    message: '',
                    show: false,
                    variant: '',
                });
            }, config.notify_time);
        }
    }, [alertState]);

    return (
        <div className="w-100">
            <div className="page-heading admin-heading">
                <div className="container-left" style={{ marginBottom: "32px" }}>
                    <div className="page-title">User Management</div>
                </div>
                <div className="manager-user-management-heading">
                  <div className='container-left w-100'>
                    <InputGroup className="datatable-search search-input">
                      <InputGroup.Append className={focus ? 'input-focus' : ''}>
                        <InputGroup.Text>
                          <img alt="..." src={searchIcon} />
                        </InputGroup.Text>
                      </InputGroup.Append>
                      <Form.Control
                        placeholder="Search..."
                        name="search"
                        value={search}
                        onChange={onSearch}
                        className="search-form"
                      />
                    </InputGroup>
                  </div>
                  <div className="container-right mt-0">
                    <Button
                      variant="primary"
                      style={{ minWidth: 160 }}
                      onClick={() => openModal('add', {})}
                    >
                      <img alt="..." src={plusIcon} />
                      Add User
                    </Button>
                  </div>
                </div>
            </div>
            <CustomAlert
                message={alertState.message}
                show={alertState.show}
                variant={alertState.variant}
                closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
            />
            <UserManagementDataTable
              data={searchData}
              loadingData={loadingData}
              openModal={openModal}
            />
            <AddUserModal
              show={showAddModal}
              onClose={closeModal}
              setAlertState={setAlertState}
              refreshData={getUserData}
              countryOptions={countryOpts}
            />
            <EditUserModal
              show={showEditModal}
              onClose={closeModal}
              setAlertState={setAlertState}
              refreshData={getUserData}
              countryOptions={countryOpts}
              row={selectedUser}
            />
        </div>
    );
};

export default UserManagement;
